import { Waypoint } from "vue-waypoint";

export default {
  name: "ScenarioParticipants",
  props: {
    data: Object,
  },
  components: {
    Waypoint,
  },
  created() {},
};
